import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Loader from '../../../components/Common/Loader/Loader';
import ViewBookingDetails from '../../../components/ViewBookingDetails';
import SocketContext from '../../../core/socketNotifications/SocketContext';
import NotFound from '../../../components/NotFound/NotFound';

import viewBookingDetails from './viewBookingDetails.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import messages from '../../../locale/messages';

export class ViewBooking extends Component {
	static propTypes = {
		data: PropTypes.shape({
			viewBookingDetails: PropTypes.object
		}),
	};

	static defaultProps = {
		data: {
			loading: true
		}
	};

	render() {
		const { formatMessage } = this.props.intl;
		const { data: { loading, viewBookingDetails, refetch }, from } = this.props;
		let title = formatMessage(messages.bookingDetails);

		if (!loading && !viewBookingDetails) {
			return <NotFound title={formatMessage(messages.pageNotFound)} />;
		} else {
			return (
				<Loader type={"page"} show={loading}>
					{!loading && viewBookingDetails &&
						<SocketContext.Consumer>
							{
								socket => (
									<ViewBookingDetails data={viewBookingDetails}
										title={title}
										from={from}
										refetch={refetch}
										socket={socket}
									/>)
							}
						</SocketContext.Consumer>
					}
				</Loader>
			)
		}

	}
}


export default compose(
	injectIntl,
	withQuery(viewBookingDetails,
		{
			options: (props) => ({
				variables: {
					id: Number(props.id)
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		})
)(ViewBooking);
